"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67820],{

/***/ 58122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38799);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64436);
/** @format */ 









function BankAccountNumber(props) {
    var inputRef = props.inputRef, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_mask__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
        ref: function(ref) {
            inputRef(ref ? ref.inputElement : null);
        },
        mask: [
            /[0-9]/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ],
        placeholderChar: " "
    }));
}
BankAccountNumber.propTypes = {
    inputRef: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
var FormattedInputs = function(param) {
    var myBankAccount = param.myBankAccount, setMyBankAccount = param.setMyBankAccount;
    var handleChange = function(event) {
        setMyBankAccount(event.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "w-full my-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    shrink: true,
                    id: "demo-simple-select-placeholder-label-label",
                    children: "계좌번호"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    value: myBankAccount,
                    onChange: handleChange,
                    name: "textmask",
                    id: "formatted-text-mask-input1",
                    inputComponent: BankAccountNumber
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FormattedInputs);


/***/ }),

/***/ 67820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var react_awesome_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20890);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94924);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85161);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79794);
/* harmony import */ var _profilePhone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29988);
/* harmony import */ var _bankAccountNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58122);
/* harmony import */ var function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89518);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/** @format */ 





// import { PhoneNumberValidator, CheckEmail } from "components/Function";










var PayInfo = function() {
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), data = ref[0], setData = ref[1];
    /* 로그인 체크 : url 이동 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_8__/* .PageTokenCheck */ .C)(settings, router);
    }, []);
    var email = settings.email;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (email) try {
            var docs = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email)).collection("settlementInfo").doc("info");
            docs.get().then(function(doc) {
                if (doc.exists) {
                    setData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, doc.data()), {
                        id: doc.id
                    }));
                }
            }).catch(function(error) {
                ;
                (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(error);
            });
        } catch (error) {
            ;
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PayInfoForm, {
            data: data
        })
    });
};
/* 디테일 페이지 상단 메뉴 */ var PayInfoForm = function(param) {
    var data = param.data;
    // const settings = useSettings();
    /* 모달 값 저장 */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible = ref[0], setModalVisible = ref[1];
    /* 정산정보 저장 */ var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myName = ref1[0], setMyName = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myPhone = ref2[0], setMyPhone = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myEmail = ref3[0], setMyEmail = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myBank = ref4[0], setMyBank = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myBankAccount = ref5[0], setMyBankAccount = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myDepositor = ref6[0], setMyDepositor = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (data) {
            var name = data.name, phone = data.phone, email = data.email, bank = data.bank, bankAccount = data.bankAccount, depositor = data.depositor;
            /* 기존 정산정보 저장 */ setMyName(name);
            setMyPhone(phone);
            setMyEmail(email);
            setMyBank(bank);
            setMyBankAccount(bankAccount);
            setMyDepositor(depositor);
        }
    }, [
        data
    ]);
    /* profile 정보 업데이트 */ // const handleProfileUpdate = async () => {
    //   // 전화번호 유효성 체크
    //   if (!PhoneNumberValidator(myPhone)) {
    //     BasicAlert("전화번호를 다시 입력해주세요.");
    //     return;
    //   }
    //   if (!myName || myName === "" || !myPhone || myPhone === "" || !myEmail || myEmail === "") {
    //     BasicAlert("정산 신청자 정보를 입력해주세요.");
    //     return;
    //   }
    //   if (!CheckEmail(myEmail)) {
    //     BasicAlert("이메일이 유효하지 않습니다.");
    //     return;
    //   }
    //   if (!myDepositor || myDepositor === "" || !myBank || myBank === "" || !myBankAccount || myBankAccount === "") {
    //     BasicAlert("입금 계좌 정보를 입력해주세요.");
    //     return;
    //   }
    //   /* 공백 제거 */
    //   const replaceMyName = myName.replace(/(\s*)/g, "");
    //   const replaceMyPhone = myPhone.replace(/(\s*)/g, "");
    //   const replaceMyEmail = myEmail.replace(/(\s*)/g, "");
    //   const replaceMyBank = myBank.replace(/(\s*)/g, "");
    //   const replaceMyBankAccount = myBankAccount.replace(/(\s*)/g, "");
    //   const replaceMyDepositor = myDepositor.replace(/(\s*)/g, "");
    //   const updateValue = {
    //     name: replaceMyName,
    //     phone: replaceMyPhone,
    //     email: replaceMyEmail,
    //     bank: replaceMyBank,
    //     bankAccount: replaceMyBankAccount,
    //     depositor: replaceMyDepositor,
    //   };
    //   /* 프로필 정보 업데이트 */
    //   try {
    //     const docRef = projectFirestore.collection("users").doc(`${settings.email}`).collection("settlementInfo").doc("info");
    //     await docRef.set(updateValue).then(() => {
    //       const text = "적용되었습니다.";
    //       SuccessAlert(text);
    //       return;
    //     });
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
    // Modal
    var closeModal = function() {
        setModalVisible(false);
    };
    var handleModalOkButton = function() {
        setModalVisible(false);
        handlePayInfoUpdate();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "lg:px-40 xl:px-52",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-ddd pb-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "text-base mb-0",
                                children: "정산 신청자 정보"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-888 text-xs mb-0",
                                children: "정보를 클릭하면 수정이 가능합니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            label: "이름",
                            placeholder: "실명 입력",
                            fullWidth: true,
                            margin: "normal",
                            InputLabelProps: {
                                shrink: true
                            },
                            className: "my-3",
                            value: myName || "",
                            onChange: function(e) {
                                return setMyName(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_profilePhone__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            myPhone: myPhone,
                            setMyPhone: setMyPhone
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            label: "e-mail",
                            placeholder: "이메일",
                            fullWidth: true,
                            margin: "normal",
                            InputLabelProps: {
                                shrink: true
                            },
                            className: "my-3 mr-3",
                            value: myEmail || "",
                            onChange: function(e) {
                                return setMyEmail(e.target.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-ddd pb-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "text-base mb-0",
                                children: "입금 계좌 설정"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-888 text-xs mb-0",
                                children: "정산 받을 계좌를 설정해 주세요"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            label: "예금주",
                            placeholder: "예금주 입력",
                            fullWidth: true,
                            margin: "normal",
                            InputLabelProps: {
                                shrink: true
                            },
                            className: "my-3",
                            value: myDepositor || "",
                            onChange: function(e) {
                                return setMyDepositor(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_bankAccountNumber__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            myBankAccount: myBankAccount,
                            setMyBankAccount: setMyBankAccount
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "my-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: "my-3 mr-3 w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    shrink: true,
                                    id: "demo-simple-select-placeholder-label-label",
                                    children: "은행 선택"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    native: true,
                                    value: myBank || "",
                                    labelId: "demo-simple-select-label",
                                    id: "demo-simple-select",
                                    onChange: function(e) {
                                        return setMyBank(e.target.value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "KB국민은행",
                                            children: "KB국민은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "신한은행",
                                            children: "신한은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "우리은행",
                                            children: "우리은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "하나은행",
                                            children: "하나은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "케이뱅크",
                                            children: "케이뱅크"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "카카오뱅크",
                                            children: "카카오뱅크"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "한국산업은행",
                                            children: "한국산업은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "중소기업은행",
                                            children: "중소기업은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "한국수출입은행",
                                            children: "한국수출입은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "NH농협은행",
                                            children: "NH농협은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "수협은행",
                                            children: "수협은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "대구은행",
                                            children: "대구은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "부산은행",
                                            children: "부산은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "경남은행",
                                            children: "경남은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "광주은행",
                                            children: "광주은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "전북은행",
                                            children: "전북은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "제주은행",
                                            children: "제주은행"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "한국씨티은행",
                                            children: "한국씨티은행"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn glass_in_btn",
                    onClick: function() {
                        return setModalVisible(true);
                    },
                    children: "적용하기"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                visible: modalVisible,
                width: "400",
                height: "210",
                effect: "fadeInUp",
                onClickAway: function() {
                    return closeModal();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "aiso-modal",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "aiso-modal-header",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "btn btn-text-grayPrimary p-3",
                                onClick: function() {
                                    return setModalVisible(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "ti-close font-bold"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "aiso-modal-body text-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-xl font-bold text-primary mb-0",
                                    id: "modal-title",
                                    children: "적용 하시겠습니까?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xs text-gray-500",
                                        children: "적용을 원하시면 확인 버튼을 눌러주세요."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "aiso-modal-footer text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-modal-o w-1/3",
                                onClick: function() {
                                    return handleModalOkButton();
                                },
                                children: "확인"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PayInfo);


/***/ })

}]);